import React from "react";
import ClickableLinkText from "../../../lib/ui/ClickableLinkText";
import { useToggleDetailSidebar } from "@src/features/sidebars/hooks/useToggleDetailSidebar";
import { DetailSidebarType } from "@src/features/sidebars/detailSidebar";

type Props = {
  children: React.ReactNode;
  id: string | number;
  sidebarType: DetailSidebarType;
  tableId: string;
  onClick?: (e: React.MouseEvent) => void;
};

const SidebarLink: React.FC<Props> = ({
  children,
  id,
  sidebarType,
  tableId,
  onClick,
}) => {
  const { toggleSidebar } = useToggleDetailSidebar();

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    toggleSidebar(
      e as React.MouseEvent<HTMLDivElement>,
      String(id),
      sidebarType,
      tableId,
    );
    onClick?.(e);
  };

  return (
    <ClickableLinkText onClick={handleClick}>{children}</ClickableLinkText>
  );
};

export default SidebarLink;
